import React from "react";

export default function IframeAPILab(){
    return(
        <div>
        {/* <iframe src="http://plnkr.co/" height="500" width="500"></iframe> */}
        <iframe src="https://betaplugin.diamondsupload.com/docplugin/y8MVd64T0ZgbWkDY6wUuEkhUSNWsT0TB" title="Embeded Code" height={"1000"} width='100%' style={{border:"none"}}></iframe>
        </div>
    )
}